var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart",style:({ 'height': _vm.height })},[_c('v-chart',{ref:"chart",attrs:{"option":_vm.opts,"update-options":{ notMerge: false },"init-options":{ renderer: 'canvas' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }